import React from 'react';

const styles = {
  competenceTag: {
    display: 'inline-block',
    padding: '2px 6px',
    margin: '3px',
    borderRadius: '4px',
    borderColor: '#555',
    color: '#555',
    borderStyle: 'solid',
    borderWidth: '1px',
    fontSize: '0.75rem',
    textDecoration: 'none',
    transition: 'none', // Override the hover transition
    background: 'none', // Ensure there's no background change on hover
  },
  competenceInverseTag: {
    display: 'inline-block',
    padding: '2px 6px',
    margin: '3px',
    borderRadius: '4px',
    borderColor: 'orange',
    color: 'orange',
    borderStyle: 'solid',
    borderWidth: '1px',
    fontSize: '0.75rem',
    textDecoration: 'none',
    transition: 'none', // Override the hover transition
    background: 'none', // Ensure there's no background change on hover
  },
};

const CompetenceTags = ({ competences }) => {
  return (
    <>
      {competences?.map((competence, index) => (
        <span key={index} style={competence.type === 'Inverse' ? styles.competenceInverseTag : styles.competenceTag}>
          {competence.estimatedExperience !== null && competence.estimatedExperience !== undefined && (
            <i id={`iconEstimatedExp-${competence.id}`} className="fas fa-bolt mx-1 text-muted">
              &nbsp;{competence.estimatedExperience}
            </i>
          )}
          <b>{competence.name ? competence.name : competence.competenceName}</b>
        </span>
      ))}
    </>
  );
};

export default CompetenceTags;
